import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';

import { LINKS } from 'constants/menus';
import { UtilitySidebar, UtilitySideBarItem } from 'components/Layouts';

const Sidebar = () => {
  const navigate = useNavigate();

  return (
    <UtilitySidebar>
      {[
        { icon: <CorporateFareOutlinedIcon />, label: 'Organization Details', link: LINKS.LENDER.SETTINGS.ORGANIZATION_DETAILS },
        { icon: <TuneOutlinedIcon />, label: 'Lending Rules', link: LINKS.LENDER.SETTINGS.LENDING_RULES },
        { icon: <RouteOutlinedIcon />, label: 'Stipulation Templates', link: LINKS.LENDER.SETTINGS.STIPULATION_TEMPLATES },
        { icon: <PeopleOutlineIcon />, label: 'User Management', link: LINKS.LENDER.SETTINGS.USERS },
      ].map(({ icon, label, link }, i) => (
        <NavLink style={{ width: '100%' }} key={`lender-settings-link-${i}`} to={link}>
          {({ isActive }) => <UtilitySideBarItem onClick={() => navigate(link)} active={isActive} icon={icon} label={label} />}
        </NavLink>
      ))}
    </UtilitySidebar>
  );
};

export default Sidebar;
